import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../images/ind-finallogo1.png";


import notifybellIcon from "../../images/notify-bell.svg";
import partnerIcon from "../../images/PartnerPref-icon.svg";
import searchIconn from "../../images/searchID.svg";
import matchesIcon from "../../images/matchesIcon.svg";
import sendInterestIcon from "../../images/sendInterestIcon.png";
import featuredProfilesIcon from "../../images/FeaturedProfiles-icon.svg";
import chatIconn from "../../images/Chat-icon.svg";
import eventIcon from "../../images/eventIcon.png";
import settingIcon from "../../images/settings-icon.svg";
import helpSupportIcon from "../../images/helpSupportIcon.png";
import customerCareIcon from "../../images/customerCare-icon.svg";
import shareIcon from "../../images/shareIcon.png";
import logoutIcon from "../../images/logout-icon.svg";
import crownIcon from "../../images/crownIcon.png";

import premiumPlusIcon from "../../images/crownIconPremium.svg";
import tillUMarryIcon from "../../images/assistedVip.png";
// import { AccountCircle, Mail } from '@mui/icons-material';
import profileImage from "../../images/no-photo.png";
import { Badge } from "@mui/material";
import { notificaionCount } from "../../asiosConfig";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import MessengerModal from "../MessengerModel";

import maleImg from "../../images/maleMatch.png";
import femaleImg from "../../images/femaleMatch.png";

// const StyledBadge = styled(Badge)(({ theme }) => ({
//   '& .MuiBadge-dot': {
//     top: '5px !important', // Adjust top position
//     right: '3px', // Adjust right position
//   },
// }));

const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#FF3C3C !important",
    color: "#fff",
    minWidth: "17px",
    height: "17px",
    fontSize: "9px",
    padding: "0",
    borderRadius: "50%",
    right: "5px",
    top: "7px",
    boxShadow: "none",
    border: "2px solid #ffebe9",
  },
}));

function UserHeader() {
  const [navOpen, setNavOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const backdropRef = useRef(null);

  const profileBtnRef = useRef(null);

  const completeStep = localStorage.getItem("last_complete_step");
  const [count, setCount] = useState(0);
  const hiddenPaths = [
    "/careerDetails",
    "/contactReligion",
    "/lifeStyle",
    "/phone-verification-otp",
  ];
  const toggleNav = () => {
    setNavOpen((prev) => !prev);
  };
  const shouldHideIcons = hiddenPaths.includes(location.pathname);
  const users = JSON.parse(localStorage.getItem("user"));
  const [userName, setUserName] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const image_path = localStorage.getItem("image_path");

  const [fullName, setFullName] = useState("");
  const [username, setUsername] = useState("");

  const [openMessengerModal, setOpenMessengerModal] = useState(false);

  const [membershipType, setMembershipType] = useState(null);


  useEffect(() => {
    const user = localStorage.getItem("user_name");
    // const profilePhoto = localStorage.getItem("profilePic");
    const account_type = localStorage.getItem("account_type");

    const storedName = localStorage.getItem("full_name");
    const storedUsername = localStorage.getItem("username");

    const membership_type = localStorage.getItem("membership_type");

if (membership_type) {
  setMembershipType(membership_type);
}


    if (storedName) setFullName(storedName);
    if (storedUsername) setUsername(storedUsername);

    const profilePhoto = localStorage.getItem("profilePic");
    const gender = localStorage.getItem("gender");

    const defaultPhoto = gender === "F" ? femaleImg : maleImg;

    if (profilePhoto && profilePhoto !== "null") {
      setPhoto(profilePhoto);
    } else {
      setPhoto(defaultPhoto);
    }

    if (user) {
      setUserName(user);
    }
    // if (profilePhoto) {
    //   setPhoto(profilePhoto);
    // }
    if (account_type) {
      setAccountType(account_type);
    }
    const fetchNotificationCount = async () => {
      try {
        const response = await notificaionCount();
        if (response.status === 200 || response.status === 201) {
          setCount(response.data.data);
        } else {
          toast.error("Failed to fetch notification count");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
    };
    fetchNotificationCount();
  }, []);
  const handleKeyDown = useCallback((event) => {
    if (event.key === "Escape") {
      setNavOpen(false);
    }
  }, []);
  const handleClickOutside = useCallback((event) => {
    // if (
    //   menuRef.current &&
    //   !menuRef.current.contains(event.target) &&
    //   backdropRef.current &&
    //   !backdropRef.current.contains(event.target)
    // )

    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      backdropRef.current &&
      !backdropRef.current.contains(event.target) &&
      profileBtnRef.current &&
      !profileBtnRef.current.contains(event.target)
    ) {
      setNavOpen(false);
    }
  }, []);
  const handleLogout = () => {
    localStorage.clear();
    navigate("/otpLogin");
    window.location.reload();
  };
  useEffect(() => {
    if (navOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navOpen, handleKeyDown, handleClickOutside]);
  return (
    <section className="topBlockBG fixed-top">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="newlogo-navbar-user">
            <a href="#">
              <img
                src={logo}
                alt="logo-img"
                style={{ width: "150px", height: "auto", objectFit: "contain" }}
              />
            </a>
          </div>
          <div className="mobileEmailSec">
            {!shouldHideIcons && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px", // space between image + bell icon
                }}
              >
                {/* PROFILE IMAGE BUTTON */}
                {/* <div
                  ref={profileBtnRef}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleNav();
                  }}
                  style={{
                    cursor: "pointer",
                    width: "45px",
                    height: "45px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #FFA65C, #FF3C3C)",
                    padding: "2px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={photo ? photo : profileImage}
                    alt="profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                      backgroundColor: "#fff", // handles missing photo gracefully
                    }}
                  />
                </div> */}

                <div
  ref={profileBtnRef}
  onClick={(e) => {
    e.stopPropagation();
    toggleNav();
  }}
  style={{
    cursor: "pointer",
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #FFA65C, #FF3C3C)",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  {/* inner circle */}
  <div
    style={{
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      overflow: "hidden",
      position: "relative",
      background: "#fff",
    }}
  >
    {/* BLURRED BACKGROUND */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        backgroundImage: `url("${photo ? photo : profileImage}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        filter: "blur(12px)",
        transform: "scale(1.2)",
      }}
    />

    {/* FOREGROUND IMAGE */}
    <img
      src={photo ? photo : profileImage}
      alt="profile"
      style={{
        position: "absolute",
        inset: 0,
        margin: "auto",
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderRadius: "50%",
      }}
    />
  </div>
</div>

                {/* NAME + USERNAME */}
                <div style={{ textAlign: "left", lineHeight: 1.1 }}>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#000",
                    }}
                  >
                    {fullName}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      opacity: 0.7,
                    }}
                  >
                    {username}
                  </div>
                </div>

                {/* NOTIFICATION ICON + BADGE */}
                <Link to="/notification">
                  <StyledBadge
                    badgeContent={count}
                    overlap="circular"
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    sx={{
                      "& .MuiBadge-badge": {
                        background: "#FF3C3C", // custom red
                        color: "#fff",
                        fontSize: "9px",
                        minWidth: "17px",
                        height: "17px",
                      },
                    }}
                  >
                    <img
                      src={notifybellIcon}
                      alt="notifications"
                      style={{
                        width: "26px",
                        height: "26px",
                        cursor: "pointer",
                      }}
                    />
                  </StyledBadge>
                </Link>
              </div>
            )}

            {/* NAV */}
            <header>
              <nav>
                <ul
                  id="menu"
                  className={navOpen ? "visible" : ""}
                  ref={menuRef}
                  style={{
                    padding: "0",
                    margin: "0 !important",
                    listStyle: "none",
                    overflowY: "auto",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      background:
                        // "linear-gradient(180deg, #F78C25 0%, #FF3C3C 100%)",
                        "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), linear-gradient(179.93deg, #f78c25, #ff3c3c)",
                      padding: "40px 20px 20px",
                      textAlign: "center",
                      color: "#fff",
                      position: "relative",
                    }}
                  >
                    {/* Close Button */}
                    <span
                      onClick={() => setNavOpen(false)}
                      style={{
                        position: "absolute",
                        top: "20px",
                        right: "20px",
                        fontSize: "28px",
                        fontWeight: "700",
                        cursor: "pointer",
                        color: "#000",
                      }}
                    >
                      ✕
                    </span>

                    {/* PROFILE TITLE */}
                    <h4
                      style={{
                        fontWeight: 700,
                        fontSize: "22px",
                        marginBottom: "20px",
                      }}
                    >
                      Profile Details
                    </h4>

                    {/* Curved WHITE ARC – this makes it look EXACTLY like Figma */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "100%",
                        height: "75px",
                        background: "#f9fafa",
                        borderTopLeftRadius: "45%",
                        borderTopRightRadius: "45%",
                      }}
                    ></div>

                    {/* Profile Image */}
                    {/* <div
                      style={{
                        marginTop: "10px",
                        position: "relative",
                        zIndex: 10,
                        width: "135px",
                        height: "135px",
                        borderRadius: "50%",
                        border: "5px solid rgba(255, 255, 255, 0.5)",
                        overflow: "hidden",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <img
                        src={photo ? photo : profileImage}
                        alt="profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div> */}

                    <div
  style={{
    marginTop: "10px",
    position: "relative",
    zIndex: 10,
    width: "135px",
    height: "135px",
    borderRadius: "50%",
    border: "5px solid rgba(255, 255, 255, 0.5)",
    overflow: "hidden",
    boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
    marginLeft: "auto",
    marginRight: "auto",
    background: "#fff",
  }}
>
  {/* BLURRED BACKGROUND */}
  <div
    style={{
      position: "absolute",
      inset: 0,
      backgroundImage: `url("${photo ? photo : profileImage}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      filter: "blur(12px)",
      transform: "scale(1.2)",
    }}
  />

  {/* FOREGROUND IMAGE */}
  <img
    src={photo ? photo : profileImage}
    alt="profile"
    style={{
      position: "absolute",
      inset: 0,
      margin: "auto",
      width: "100%",
      height: "100%",
      objectFit: "contain",
      borderRadius: "50%",
    }}
  />
</div>

                    {/* View Profile Button */}
                    <div
                      onClick={() => {
                        setNavOpen(false);
                        navigate("/view-profile");
                      }}
                      style={{
                        margin: "-15px auto 0",
                        width: "150px",
                        background:
                          // "linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
                          "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))",
                        height: "34px",
                        borderRadius: "20px",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#f9fafa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        zIndex: 10,
                        position: "relative",
                      }}
                    >
                      View full profile
                    </div>
                  </div>

                  {/* NAME + USERNAME */}
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "0px",
                      marginBottom: "0px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: "26px",
                        color: "#000",
                        lineHeight: "1.2",
                      }}
                    >
                      {fullName}
                    </div>

                    {/* <div
                      style={{
                        fontSize: "14px",
                        opacity: 0.7,
                        marginTop: "4px",
                      }}
                    >
                      {username}
                    </div> */}

                    
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontSize: "14px",
    marginTop: "4px",
    color: "rgba(0,0,0,0.7)",
    lineHeight: "1",
  }}
>
  <span>{username}</span>

  {membershipType && membershipType !== "Free" && (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "4px 6px",
        borderRadius: "15px",
        border: "1px solid #ff3c3c",
        fontSize: "11px",
        fontWeight: 600,
        color: "#070707",
        backgroundColor: "#ffffff",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={
          membershipType === "Premium+"
            ? premiumPlusIcon
            : membershipType === "Premium"
              ? premiumPlusIcon
              : membershipType === "Assisted"
                ? tillUMarryIcon
                : null
        }
        alt={membershipType}
        style={{
          width: "15px",
          height: "15px",
          display: "block",
        }}
      />
      {membershipType}
    </span>
  )}
</div>


                    {/* BOTTOM DIVIDER */}
                    <div
                      style={{
                        margin: "10px auto 0",
                        width: "70%",
                        height: "2px",
                        background:
                          "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))",
                        borderRadius: "2px",
                      }}
                    />
                  </div>

                  <div style={{ padding: "10px 20px" }}>
                    {[
                      {
                        label: "Partner Preferences",
                        icon: partnerIcon,
                        link: "/view-profile",
                      },

                       {
                        label: "Search",
                        icon: searchIconn,
                        link: "/search",
                      },
                      {
                        label: "My Matches",
                        icon: matchesIcon,
                        link: "/my_matches",
                      },
                      {
                        label: "Featured Profiles",
                        icon: featuredProfilesIcon,
                        link: "/featured_profile",
                      },
                      {
                        label: "Customer Care",
                        icon: customerCareIcon,
                        link: "/customer-care",
                      },
                      {
                        label: "Messenger",
                        icon: chatIconn,
                        onClick: () => {
                          setNavOpen(false);
                          setOpenMessengerModal(true);
                        },
                      },
                     
                      {
                        label: "Settings",
                        icon: settingIcon,
                        link: "/setting",
                      },
                      
                      {
                        label: "Logout",
                        icon: logoutIcon,
                        onClick: handleLogout,
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          if (item.link) navigate(item.link);
                          if (item.onClick) item.onClick();
                          setNavOpen(false);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                          padding: "12px 0",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "6px",
                            background: "#fff",
                            border: "1px solid #EFECEC",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={item.icon}
                            alt=""
                            style={{ width: "36px", height: "36px" }}
                          />
                        </div>

                        <span style={{ fontSize: "16px", fontWeight: "500" }}>
                          {item.label}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* <div style={{ padding: "0 20px 20px" }}>
                    <div
                      onClick={() => navigate("/upgrade")}
                      style={{
                        background:
                          "linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",

                        padding: "14px",
                        borderRadius: "12px",
                        textAlign: "center",
                        fontWeight: "700",
                        color: "#fff",
                        fontSize: "15px",
                        cursor: "pointer",
                        position: "relative",
                        border: "2px solid #fff",
                      }}
                    >
                      Upgrade Membership
                      <img
                        src={crownIcon}
                        alt=""
                        style={{
                          width: "22px",
                          height: "22px",
                          position: "absolute",
                          right: "15px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      />
                    </div>
                  </div> */}

                  <div style={{ padding: "0 20px 20px" }}>
                    <div
                      onClick={() => {
                        setNavOpen(false);
                        navigate("/upgrade");
                      }}
                      // onClick={() => navigate("/upgrade")}
                      style={{
                        width: "100%",
                        height: "54px",
                        position: "relative",
                        cursor: "pointer",
                        textAlign: "center",
                        fontFamily: "Montserrat",
                      }}
                    >
                      {/* Gradient Background */}
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "291px",
                          height: "54px",
                          borderRadius: "8px",
                          background:
                            "linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))",
                          opacity: 0.8,
                        }}
                      />

                      {/* Inner White Border */}
                      <div
                        style={{
                          position: "absolute",
                          top: "6px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "275px",
                          height: "41px",
                          borderRadius: "8px",
                          border: "1.5px solid #fff",
                          boxSizing: "border-box",
                          backgroundColor: "transparent",
                        }}
                      />

                      {/* Text */}
                      <div
                        style={{
                          position: "absolute",
                          top: "18px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          fontSize: "15px",
                          fontWeight: 600,
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "18px",
                          width: "170px",
                          zIndex: 2,
                        }}
                      >
                        Upgrade Membership
                      </div>

                      {/* Icon */}
                      <img
                        src={crownIcon}
                        alt="upgrade"
                        style={{
                          position: "absolute",
                          top: "17px",
                          right: "calc(50% - 145px + 16px)",
                          width: "23px",
                          height: "23px",
                          zIndex: 2,
                        }}
                      />
                    </div>
                  </div>
                </ul>

                {navOpen && (
                  <div
                    id="backdrop"
                    className="backdrop backdrop--visible"
                    aria-hidden="true"
                    ref={backdropRef}
                    onClick={() => setNavOpen(false)}
                  ></div>
                )}
              </nav>
            </header>
            {/* NAV */}
          </div>
        </div>
      </div>
      <MessengerModal
        open={openMessengerModal}
        onClose={() => setOpenMessengerModal(false)}
      />
    </section>
  );
}

export default UserHeader;
